import * as assets from './assets';
import * as exports from './exports';
import * as imports from './imports';
import * as integration from './integration';
import * as download from './download';
import * as user from './user';
import * as organization from './organization';
import * as dashboard from './dashboard';
import * as channel from './channel';
import * as customFields from './custom-fields';
import * as reports from './reports';
import * as inventory from './inventory';
import * as kit from './kit';
import * as product from './product';
import * as order from './order';
import * as preview from './preview';
import * as pricing from './pricing';

export const endpoints = {
  assets,
  exports,
  imports,
  integration,
  download,
  user,
  organization,
  dashboard,
  channel,
  customFields,
  reports,
  inventory,
  kit,
  order,
  preview,
  pricing,
  product,
};
